import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { LoginPage } from "./pages/auth/LogInPage";
import { HomePage } from "./pages/homePage/HomePage";

import { CategoryPage } from "./pages/category/CategoryPage";
import { ErrorPage } from "./pages/error/ErrorPage";
import { OrderPage } from "./pages/order/OrderPage";
import { OrderDetailPage } from "./pages/order/orderDetail/OrderDetailPage";
import { OrderOutlet } from "./pages/order/OrderOutlet";
import { CancellationPage } from "./pages/cancellation/CancellationPage";
import { RefundPage } from "./pages/refund/RefundPage";
import { RefundOutlet } from "./pages/refund/RefundOutlet";
import { RefundDetailPage } from "./pages/refund/refundDetail/RefundDetailPage";
import { CancellationOutlet } from "./pages/cancellation/CancellationOutlet";
import { CancellationDetailPage } from "./pages/cancellation/cancellationDetail/CancellationDetailPage";
import { ProductListPage } from "./pages/category/productList/ProductListPage";
import { ProductDetailPage } from "./pages/category/productDetail/ProductDetailPage";
import { RootLayout } from "./pages/RootLayout";

import "./App.css";
import {
  checkAuthLoader,
  DashBoardPage,
} from "./pages/dashBoard/DashBoardPage";
import { BulkOutlet } from "./pages/bulk/BulkOutLet";
import { BulkSparesPage } from "./pages/bulk/bulkSpares/BulkSparesPage";
import { BulkSparesListPage } from "./pages/bulk/bulkSpares/bulkSparesList/BulkSparesListPage";
import { BulkSpareDetailPage } from "./pages/bulk/bulkSpareDetail/BulkSpareDetailPage";
import { Children } from "react";
import { BulkSpareLotListOutlet } from "./pages/bulk/bulkSpareLotList/BulkSpareLotListOutlet";
import { BulkSpareLotListPage } from "./pages/bulk/bulkSpareLotList/BulkSpareLotListPage";
import { BulkSpareLotListItemDetailPage } from "./pages/bulk/bulkSpareLotList/bulkSpareLotListItemDetail/BulkSpareLotListItemDetailPage";
import { BulkSpareHelperOutlet } from "./pages/bulk/bulkSpareDetail/BulkSpareHelperOutlet";
import { InventoryOutlet } from "./pages/inventory/InventoryOutlet";
import { InventorySparesOutlet } from "./pages/inventory/inventorySparesPage/InventorySparesOutlet";
import { InventorySparesListingPage } from "./pages/inventory/inventorySparesPage/inventorySparesListingPage/InventorySparesListingPage";
import { InventorySparesLotListPage } from "./pages/inventory/inventorySparesLotListPage/InventorySparesLotListPage";
import { InventorySparesLotItemDetailPage } from "./pages/inventory/inventorySparesLotListPage/inventorySparesLotListTable/inventorySparesLotItemDetailPage/InventorySparesLotItemDetailPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    loader: checkAuthLoader,
    children: [
      {
        element: <DashBoardPage />, // dashboard wrapper
        children: [
          { index: true, element: <HomePage /> },
          {
            path: "bulk_deals",
            element: <BulkOutlet />,
            children: [
              {
                path: "spares",
                element: <BulkSparesPage />,
                children: [
                  { index: true, element: <BulkSparesListPage /> }, // /bulk_deals/spares

                  {
                    path: ":request_id",
                    element: <BulkSpareHelperOutlet />,
                    children: [
                      { index: true, element: <BulkSpareDetailPage /> },
                      {
                        path: "items",
                        element: <BulkSpareLotListOutlet />, // optional outlet for items
                        children: [
                          { index: true, element: <BulkSpareLotListPage /> }, // /bulk_deals/spares/:request_id/items
                          {
                            path: ":item_id",
                            element: <BulkSpareLotListItemDetailPage />, // /bulk_deals/spares/:request_id/items/:item_id
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },

          
          {
            path: "inventory",
            element: <InventoryOutlet />,
            children: [
              {
                path: "spares",
                element: <InventorySparesOutlet />,
                children: [
                  { index: true, element: <InventorySparesListingPage /> },
                  {
                    path: ":inventoryId",
                    element: <InventorySparesLotListPage />,
                  },
                  {
                    path: ":inventoryId/:lotItemId",
                    element: <InventorySparesLotItemDetailPage />,
                  },
                ],
              },
            ],
          },

          {
            path: "orders",
            element: <OrderOutlet />,
            children: [
              { index: true, element: <OrderPage /> },
              { path: ":orderId", element: <OrderDetailPage /> },
            ],
          },

          {
            path: "cancelled_orders",
            element: <CancellationOutlet />,
            children: [
              { index: true, element: <CancellationPage /> },
              { path: ":cancellationId", element: <CancellationDetailPage /> },
            ],
          },

          {
            path: "refund_orders",
            element: <RefundOutlet />,
            children: [
              { index: true, element: <RefundPage /> },
              { path: ":refundId", element: <RefundDetailPage /> },
            ],
          },
        ],
      },
    ],
  },

  {
    path: "/login",
    element: <LoginPage />,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
